<template>
  <div>
    <div class="right-title">
      <span>修改密码</span>
    </div>
    <div class="content-box">
      <div class="gw-info-box">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
          <el-form-item label="旧密码：" prop="oldPass">
            <el-input type="password" v-model="form.oldPass" placeholder="请输入旧密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码：" prop="pass">
            <el-input type="password" placeholder="请输入新密码" v-model="form.pass" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="checkPass">
            <el-input type="password" placeholder="请确认密码" v-model="form.checkPass" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="submit" @click="onSubmit()">完成</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "passSet",
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value.length < 6) {
          callback(new Error('请输入6位以上的密码'));
        } else {
          if (this.form.checkPass !== '') {
            this.$refs.form.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value.length < 6) {
          callback(new Error('请输入6位以上的密码'));
        } else if (value !== this.form.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        form: {
          oldPass: '',     //  旧密码
          pass: '',       //  新密码
          checkPass: ''   //  确认密码
        },
        rules: {
          oldPass: [
            {required: true, message: '请输入旧密码', trigger: 'blur'},
            {min: 6, message: '旧密码长度需六位字符以上', trigger: 'blur'}
          ],
          pass: [
            {required: true, validator: validatePass, trigger: 'blur'}
          ],
          checkPass: [
            {required: true, validator: validatePass2, trigger: 'blur'}
          ],
        }
      }
    },
    created() {

    },
    computed: {
      user(){
        return this.$store.state.user
      }
    },
    methods: {
      onSubmit() {
        this.$api.apiContent.gaiPass({
          jupass:this.$md5(this.form.oldPass),
          xinpass:this.$md5(this.form.pass),
          xinpassq:this.$md5(this.form.checkPass),
          admin_id:this.user.id,
        }).then(res => {
          this.$message.success(res.info);
          this.form.oldPass = ''
          this.form.pass = ''
          this.form.checkPass = ''
        }).catch(res => {
          this.$message.error(res.info);
        })
      },
    },
    watch: {},
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .gw-info-box {
    width: 360px;
    padding: 50px 0;
    margin: 0 auto;

  }

  .submit {
    width: 100%;
  }
</style>